import { Container, Stack, Typography } from '@mui/material'
import React from 'react'
import logo from './Media/focus logo.png';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";

export default function Footer() {
    const navigate = useNavigate()
    const { t } = useTranslation();

  return (
    <div style={{ backgroundColor:'white',height:'20%',backgroundColor:'#D8D8D842' }}>
        <Container>
        <Stack direction='row'>
            <img src={logo} style={{width:"200px", height:'100px',objectFit:'cover',cursor:'pointer'}} 
            onClick={()=>{window.scrollTo(0, 0)}}/>
            <Typography sx={{ color:'white',marginTop:'30px' }}>
            {t('© 2024 Focus Trading Company.All Rights Reserved')}
            </Typography>
        </Stack>
        </Container>
    </div>
  )
}
